import http from "@/shared/services/http";

export const singlePickingListReTransport = (id: number) => http.get(`v1/picking-list-re-transports/${id}`);
export const listBillLadingByPickingListReTransportId = (id: number) => http.get(`v1/picking-list-re-transports/${id}/bill-ladings`);
export const listPickingListReTransport = (params: any) => http.get(`v1/picking-list-re-transports`, {params});
export const deletePickingListReTransport = (id: number) => http.delete(`v1/picking-list-re-transports/${id}`);
